import * as React from "react";
const SvgFiRrCoffeeBean = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coffee-bean_svg__a)">
      <path
        fill="#062147"
        d="M21.257 2.743C17.048-1.465 9.474-.731 4.372 4.372-.732 9.477-1.463 17.051 2.743 21.257c1.838 1.838 4.318 2.733 6.954 2.733 3.398 0 7.057-1.488 9.931-4.362 5.104-5.104 5.835-12.679 1.63-16.885M5.787 5.786c2.49-2.489 5.635-3.788 8.511-3.788 1.93 0 3.74.586 5.145 1.79-.26 1.264-1.568 5.329-7.74 7.258-5.623 1.757-7.819 5.141-8.67 7.328-2.05-3.561-1.01-8.824 2.753-12.587zm12.427 12.428c-4.16 4.159-10.155 4.995-13.657 1.998.261-1.265 1.57-5.328 7.741-7.258 5.622-1.757 7.818-5.141 8.67-7.328 2.05 3.561 1.01 8.824-2.754 12.587z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coffee-bean_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoffeeBean;
